import React from 'react';
import "../../styles/contact/main.css";
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <>
            {/* Inner Container */}
            <div className="container contact-container">
                <div className="row w-100 m-0 p-0">
                    {/* Address Card */}
                    <div className="col-lg-4">
                        <div className="card contact-card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <i className="fas fa-map-marker-alt" /> Address
                                </h5>
                                <p className="card-text">
                                    Chaudhary Charan Singh University, Ramgarhi, Meerut, Uttar Pradesh
                                    250004
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Contact Details Card */}
                    <div className="col-lg-4">
                        <div className="card contact-card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <i className="fa-regular fa-address-card" /> Contact Details
                                </h5>
                                <p className="card-text">
                                    Phone: <a href="tel:+911212763539">+91-0121 2604570</a>
                                    <br />
                                    <a href="mailto:registrar@ccsuniversity.ac.in">
                                        Email: registrar@ccsuniversity.ac.in
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Directory Card */}
                    <div className="col-lg-4">
                        <div className="card contact-card">
                            <div className="card-body">
                                <h5 className="card-title">
                                    <i className="fa-regular fa-address-book" /> Directory
                                </h5>
                                <p className="card-text">
                                    Search the{" "}
                                    <Link to="/enquiry-numbers" title="Directory">
                                        Directory
                                    </Link>{" "}
                                    for listings of all people and locations in CCSU Meerut
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Please note */}
                <div className="row w-100 m-0 p-0">
                    <div className="col-lg-12">
                        <p className="text-center mt-4">
                            <b>Please note:</b> The Offices, Departments, Research Centres and
                            other Facilities have their own numbers. Please consult the Directory
                            or the Department/Centre websites.
                        </p>
                    </div>
                </div>
                <div className="row p-0 m-0 w-100 d-flex justify-content-center align-items-center">
                    <div className="col-lg-12">
                        {/* Google Maps Embed */}
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3490.6152460057974!2d77.73831541509024!3d28.96913438228628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c64b5d11357e7%3A0xe77b4a696e5c5841!2sChaudhary+Charan+Singh+University!5e0!3m2!1sen!2sin!4v1564637156136!5m2!1sen!2sin"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title='map'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Main;